import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../app/AuthProvider";

/**
 * Auth guard — IAuthAdapter üzerinden çalışır (Faz 6).
 * Backend swap edilse de (Mock ↔ Jwt) bu component değişmez.
 */
const PrivateRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return isAuthenticated ? (
    <Outlet />
  ) : (
    <Navigate to={`${""}/login`} replace />
  );
};

export default PrivateRoute;
